import React, { useState, useContext, useEffect } from "react";
import Input from "../../modals/parts/Input";
import Select from "../../components/Select";
import { useDispatch } from "react-redux";
import { confirm } from "../../redux/actions/modal";
import List from "../../modals/parts/List";
import SwapSettings from "../../modals/SwapSettings";
import { swapSettingsData } from "../../placeholder";
import { sf, currencies } from "./currencies";
import {
  swap,
  approveErc20,
  isErc20Approved,
  calcFee,
  calcTokensOut,
  calcPrice,
  getERC20BalanceByAddress,
  getERC20BalanceFromAddress,
} from "../../apis/blockchain";
import { Web3Context } from "../../contexts/Web3Context";
import { ethers } from "ethers";

export default function () {
  const dispatch = useDispatch();
  const Swal = require("sweetalert2");
  const [fee, setFee] = useState("");
  const [max, setMax] = useState(0);
  const [settings, setSettings] = useState(false);
  const [formData, setFormData] = useState({
    from: "",
    to: "",
    selectfrom: sf[0],
    selectto: sf[1],
  });

  const [settingsData, setSettingsData] = useState({
    slippage: 0.1,
    slippageInput: "",
    deadline: "20",
  });

  const web3Context = useContext(Web3Context);

  const [isApproved, setIsApproved] = useState(false);
  const [balance, setBalance] = useState(0);
  const [tokensOut, setTokensOut] = useState("");
  const [price, setPrice] = useState("1");
  const [priceImpact, setPriceImpact] = useState("");

  useEffect(() => {
    checkApproved();
    calculateFee();
    findBalance();
    calculateTokensOut();
    findPrice();
    findPriceImpact();
  }, [formData, web3Context]);

  const findBalance = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = currencies[formData.selectfrom.value].address;
      let balanceNew = await getERC20BalanceByAddress(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress
      );

      console.log(balanceNew.toString());

      if (
        tokenAddress == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
        tokenAddress == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
      ) {
        balanceNew = ethers.utils.formatUnits(balanceNew, 6);
      } else {
        balanceNew = ethers.utils.formatEther(balanceNew);
      }

      balanceNew = parseInt(balanceNew * 1000000) / 1000000;

      setBalance(balanceNew);
      setMax(balanceNew);
    }
  };

  const checkApproved = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = currencies[formData.selectfrom.value].address;
      const approved = await isErc20Approved(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress,
        web3Context.web3.rAskoSwapRouterContract.address
      );
      setIsApproved(approved);
    }
  };

  const checkBalance = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = currencies[formData.selectfrom.value].address;
      const bal = await getERC20BalanceFromAddress(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress
      );
      const formatted = (
        bal /
        10 ** currencies[formData.selectfrom.value].decimals
      ).toString();
      setBalance(formatted);
    }
  };

  const approve = async () => {
    const fromToken = currencies[formData.selectfrom.value];

    await approveErc20(
      web3Context.web3.web3Provider,
      fromToken.address,
      web3Context.web3.rAskoSwapRouterContract.address
    );
    setIsApproved(true);
  };

  const fromToken = currencies[formData.selectfrom.value];
  const toToken = currencies[formData.selectto.value];
  const path = [fromToken.address, toToken.address];

  let slippage;

  if (settingsData.slippageInput) {
    slippage = parseFloat(settingsData.slippageInput);
  } else {
    slippage = settingsData.slippage;
  }

  const amount = formData.from * 10 ** fromToken.decimals;
  const minimum =
    parseInt((tokensOut - (tokensOut * slippage) / 100) * 1000000) / 1000000;
  const deadline = settingsData.deadline * 60;

  const submit = async () => {
    const tokenAddressA = currencies[formData.selectfrom.value].address;
    const tokenAddressB = currencies[formData.selectto.value].address;
    if (formData.from > balance) {
      Swal.fire({
        text: "Insufficient token balance.",
        icon: "info",
        confirmButtonText: "Ok",
      });
      // alert("Insufficient token balance.");
      return;
    }

    let request =
      tokenAddressA == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
      tokenAddressA == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
        ? ethers.utils.parseUnits(formData.from.toString(), 6)
        : ethers.utils.parseEther(formData.from.toString());

    let minOut =
      tokenAddressB == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
      tokenAddressB == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
        ? ethers.utils.parseUnits(minimum.toString(), 6)
        : ethers.utils.parseEther(minimum.toString());

    swap(
      web3Context.web3.rAskoSwapRouterContract,
      request,
      minOut,
      path,
      web3Context.currentAccountAddress,
      deadline + parseInt(Date.now() / 1000),
      web3Context.web3.rAskoSwapLibraryContract
    );
  };

  const calculateFee = async () => {
    if (!web3Context.currentAccountAddress) {
      return;
    }

    try {
      let _fee = await calcFee(
        web3Context.web3.rAskoSwapRouterContract,
        amount + "",
        parseInt(minimum).toString(),
        path,
        web3Context.currentAccountAddress,
        deadline + "",
        web3Context.web3.rAskoSwapLibraryContract
      );

      _fee =
        parseInt(ethers.utils.formatEther(_fee.toString()) * 1000000) / 1000000;

      setFee(_fee);
      return;
    } catch (error) {
      setFee("");
      return;
    }
  };

  const calculateTokensOut = async () => {
    if (!web3Context.currentAccountAddress) {
      return;
    }
    const tokenAddress = currencies[formData.selectto.value].address;

    try {
      let _tokensOut = await calcTokensOut(
        web3Context.web3.rAskoSwapRouterContract,
        amount + "",
        path,
        web3Context.web3.rAskoSwapLibraryContract
      );

      // _tokensOut =
      //   parseInt(ethers.utils.formatEther(_fee.toString()) * 1000000) / 1000000;

      if (
        tokenAddress == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
        tokenAddress == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
      ) {
        _tokensOut = ethers.utils.formatUnits(_tokensOut.toString(), 6);
      } else {
        _tokensOut = ethers.utils.formatEther(_tokensOut.toString());
      }

      setTokensOut(_tokensOut);
      return;
    } catch (error) {
      setTokensOut("");
      return;
    }
  };

  const findPrice = async () => {
    if (!web3Context.currentAccountAddress) {
      return;
    }
    const tokenA = currencies[formData.selectfrom.value].address;
    const tokenB = currencies[formData.selectto.value].address;

    try {
      let _price = await calcPrice(
        web3Context.web3.rAskoSwapRouterContract,
        tokenA,
        tokenB,
        web3Context.web3.rAskoSwapLibraryContract
      );

      _price = parseInt(_price * 1000000) / 1000000;

      setPrice(_price.toString());
      return;
    } catch (error) {
      setPrice("");
      return;
    }
  };

  const findPriceImpact = async () => {
    let newPrice = tokensOut / formData.from;
    let originalPrice = price;
    let priceImpact = ((newPrice - originalPrice) / originalPrice) * 100;
    if (priceImpact < 0) {
      priceImpact = parseInt(Math.abs(priceImpact) * 100) / 100;
    } else {
      priceImpact = 0;
    }

    setPriceImpact(priceImpact);
  };

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const buttonInverseHandler = (e) => {
    e.preventDefault();

    setFormData({
      from: formData.to,
      to: formData.from,
      selectfrom: formData.selectto,
      selectto: formData.selectfrom,
    });
  };

  return (
    <form className="swap-form" onSubmit={(e) => e.preventDefault()}>
      <div className="swap-form__header">
        <span>&nbsp;</span>

        <button
          className="swap-form__settings"
          onClick={() => setSettings(!settings)}
        ></button>
        {settings === true && (
          <SwapSettings
            onClose={() => setSettings(false)}
            data={swapSettingsData}
            settingsData={settingsData}
            setSettingsData={setSettingsData}
          />
        )}
      </div>

      <div className="swap-form__body">
        <div className="swap-form__title">
          <span>From</span>
          <span>Balance: {balance}</span>
        </div>

        <div className="swap-form__field">
          <Input
            className="swap-form__input"
            type="text"
            name="from"
            value={formData.from}
            onChange={changeHandler}
            maxEnable={true}
            maxHandler={() => setFormData({ ...formData, from: balance })}
          />
          <div className="swap-form__select">
            <Select
              className="sf__select"
              current={formData.selectfrom.value}
              setValue={changeHandler}
              name="selectfrom"
            >
              {sf.map((item) => (
                <Select.Item key={item.id} item={item} />
              ))}
            </Select>
          </div>
        </div>
        <button
          className="swap-form__img-btn swap-form__img"
          onClick={buttonInverseHandler}
        >
          <img
            src="/assets/images/page-icons/arrows-exchange.svg"
            alt="exchange"
          />
        </button>

        <div className="swap-form__title swap-form__title_mt">
          <span>To</span>
        </div>

        <div className="swap-form__field">
          <Input
            className="swap-form__input"
            type="text"
            name="to"
            value={tokensOut}
            onChange={changeHandler}
            readonly={true}
          />
          <div className="swap-form__select">
            <Select
              className="sf__select"
              current={formData.selectto.value}
              setValue={changeHandler}
              name="selectto"
            >
              {sf.map((item) => (
                <Select.Item key={item.id} item={item} />
              ))}
            </Select>
          </div>
        </div>

        <div className="swap-form__subtitle">
          <span className="sf-blue">Price</span>
          <span className="sf-bprice">
            1 {formData.selectfrom.value} = {price} {formData.selectto.value}
          </span>
        </div>

        {isApproved ? (
          <button
            type="submit"
            className="custom-button swap-form__submit"
            onClick={submit}
          >
            <span>Swap</span>
          </button>
        ) : (
          <button
            type="submit"
            className="custom-button swap-form__submit"
            onClick={approve}
          >
            <span>Approve</span>
          </button>
        )}
      </div>

      <div className="swap-form__list">
        <List>
          <List.Item title="Minimum Received" value={minimum} />
          <List.Item title="Price Impact" value={priceImpact + "%"} />
          <List.Item title="Fee" value={fee} />
        </List>
      </div>
    </form>
  );
}
